<template>
    <el-input
        :value="auditDataValue"
        type="number"
        step="any"
        @input="saveNewValue"
    ></el-input>
</template>

<script>

export default {

    components: {

    },

    props: {
        auditDataValue: {
            type: [Number, String],
            required: true
        },
        solutionIndex: {
            type: Number,
            required: true
        },
        overridableKey: {
            type: String,
            required: true
        },
        motor: {
            type: String,
            required: true
        }
    },

    data: function(){
        return {

        };
    },

    computed: {

    },

    mounted: function(){

    },

    methods: {
        saveNewValue (val) {
            this.$emit('saveNewValue', {
                value: val,
                motor: this.motor,
                overridableKey: this.overridableKey,
                solutionIndex: this.solutionIndex
            })
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/report/overriddenAuditDataInput.vue